import {
  FilteringSequence3rfik2d45zn1y as FilteringSequence,
  TransformingSequence3gzv034v2j93f as TransformingSequence,
  FlatteningSequence1gb46kmahgjp0 as FlatteningSequence,
  TakeSequencecj2mz1r3ww35 as TakeSequence,
  DropTakeSequence18qfczyunxcax as DropTakeSequence,
  emptySequence25zpp7hgtqwdd as emptySequence,
  TakeWhileSequencew23yaim82axu as TakeWhileSequence,
  sequenceOf1mtha40gp6gat as sequenceOf,
  flatten21nlxz4anepug as flatten,
  DistinctSequence1lbisrkxedews as DistinctSequence,
} from './Sequences.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../collections/CollectionsKt.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  setOf1u3mizs95ngxo as setOf,
} from '../collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { sequence2vgswtrxvqoa7 as sequence } from './SequenceBuilder.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../collections/Sets.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../collections/LinkedHashSet.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import {
  Sequence$iterator$ref2j76hcuuhqjnf as Sequence$iterator$ref,
  Sequence1quqbxersk0bb as Sequence,
} from './Sequence.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  Iterable$iterator$ref3u1hw41cq8ldt as Iterable$iterator$ref,
  Iterable1y3qizuf89iou as Iterable,
} from '../collections/Collections.mjs';
import { appendElement7nmjunfw9r4 as appendElement } from '../text/Appendable.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../js/reflectRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function filter(_this__u8e3s4, predicate) {
  return new (FilteringSequence())(_this__u8e3s4, true, predicate);
}
function toList(_this__u8e3s4) {
  var it = _this__u8e3s4.iterator_jk1svi_k$();
  if (!it.hasNext_bitz1p_k$())
    return emptyList();
  var element = it.next_20eer_k$();
  if (!it.hasNext_bitz1p_k$())
    return listOf(element);
  var dst = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  dst.add_utx5q5_k$(element);
  while (it.hasNext_bitz1p_k$()) {
    dst.add_utx5q5_k$(it.next_20eer_k$());
  }
  return dst;
}
function map(_this__u8e3s4, transform) {
  return new (TransformingSequence())(_this__u8e3s4, transform);
}
function sum(_this__u8e3s4) {
  var sum = 0.0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    sum = sum + element;
  }
  return sum;
}
function zipWithNext(_this__u8e3s4, transform) {
  return sequence(zipWithNext$slambda(_this__u8e3s4, transform));
}
function firstOrNull(_this__u8e3s4) {
  var iterator = _this__u8e3s4.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    return null;
  return iterator.next_20eer_k$();
}
function mapNotNull(_this__u8e3s4, transform) {
  return filterNotNull(new (TransformingSequence())(_this__u8e3s4, transform));
}
function toSet(_this__u8e3s4) {
  var it = _this__u8e3s4.iterator_jk1svi_k$();
  if (!it.hasNext_bitz1p_k$())
    return emptySet();
  var element = it.next_20eer_k$();
  if (!it.hasNext_bitz1p_k$())
    return setOf(element);
  var dst = LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
  dst.add_utx5q5_k$(element);
  while (it.hasNext_bitz1p_k$()) {
    dst.add_utx5q5_k$(it.next_20eer_k$());
  }
  return dst;
}
function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  return joinTo(_this__u8e3s4, StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$(), separator, prefix, postfix, limit, truncated, transform).toString();
}
function flatMap(_this__u8e3s4, transform) {
  return new (FlatteningSequence())(_this__u8e3s4, transform, Sequence$iterator$ref());
}
function distinct(_this__u8e3s4) {
  return distinctBy(_this__u8e3s4, distinct$lambda);
}
function take(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  var tmp;
  if (n === 0) {
    tmp = emptySequence();
  } else {
    if (isInterface(_this__u8e3s4, DropTakeSequence())) {
      tmp = _this__u8e3s4.take_6gva4v_k$(n);
    } else {
      tmp = new (TakeSequence())(_this__u8e3s4, n);
    }
  }
  return tmp;
}
function takeWhile(_this__u8e3s4, predicate) {
  return new (TakeWhileSequence())(_this__u8e3s4, predicate);
}
function plus(_this__u8e3s4, elements) {
  return flatten(sequenceOf([_this__u8e3s4, elements]));
}
function filterNotNull(_this__u8e3s4) {
  var tmp = filterNot(_this__u8e3s4, filterNotNull$lambda);
  return isInterface(tmp, Sequence()) ? tmp : THROW_CCE();
}
function flatMap_0(_this__u8e3s4, transform) {
  return new (FlatteningSequence())(_this__u8e3s4, transform, Iterable$iterator$ref());
}
function asIterable(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new (asIterable$$inlined$Iterable$1())(_this__u8e3s4);
}
function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  buffer.append_jgojdo_k$(prefix);
  var count = 0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    count = count + 1 | 0;
    if (count > 1) {
      buffer.append_jgojdo_k$(separator);
    }
    if (limit < 0 || count <= limit) {
      appendElement(buffer, element, transform);
    } else
      break $l$loop;
  }
  if (limit >= 0 && count > limit) {
    buffer.append_jgojdo_k$(truncated);
  }
  buffer.append_jgojdo_k$(postfix);
  return buffer;
}
function distinctBy(_this__u8e3s4, selector) {
  return new (DistinctSequence())(_this__u8e3s4, selector);
}
function filterNot(_this__u8e3s4, predicate) {
  return new (FilteringSequence())(_this__u8e3s4, false, predicate);
}
function zipWithNext$slambda($this_zipWithNext, $transform) {
  return constructCallableReference(($this$result, $completion) => orPromise($completion, function *($completion) {
    var iterator = $this_zipWithNext.iterator_jk1svi_k$();
    var tmp;
    if (!iterator.hasNext_bitz1p_k$()) {
      return Unit_instance;
    }
    var current = iterator.next_20eer_k$();
    while (iterator.hasNext_bitz1p_k$()) {
      var next = iterator.next_20eer_k$();
      yield* $this$result.yield_3xhcex_k$($transform(current, next), $completion);
      current = next;
    }
    return Unit_instance;
  }), 1);
}
function distinct$lambda(it) {
  return it;
}
function filterNotNull$lambda(it) {
  return it == null;
}
var asIterable$$inlined$Iterable$1Class;
function asIterable$$inlined$Iterable$1() {
  if (asIterable$$inlined$Iterable$1Class === VOID) {
    class $ {
      constructor($this_asIterable) {
        this.$this_asIterable_1 = $this_asIterable;
      }
      iterator_jk1svi_k$() {
        return this.$this_asIterable_1.iterator_jk1svi_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Iterable()]);
    asIterable$$inlined$Iterable$1Class = $;
  }
  return asIterable$$inlined$Iterable$1Class;
}
//region block: exports
export {
  asIterable as asIterable1fxmj7vyh9cyo,
  distinct as distinct17vua5ffe1cfv,
  filterNotNull as filterNotNull7zp8mkmr5zva,
  filter as filter184huxd00uyfg,
  firstOrNull as firstOrNull175qkyx53x0vd,
  flatMap as flatMapgxtanzi5fvh9,
  flatMap_0 as flatMap1gb3cjy1dqv3d,
  joinToString as joinToStringooja5rkatz3u,
  mapNotNull as mapNotNull3b8ce5hky4k2l,
  map as mapsbvh18eqox7a,
  plus as plus2l6bq32n2wlna,
  sum as sum21i2pabt6cxsw,
  takeWhile as takeWhile17zwcj046i086,
  take as take2rh6pen3z50h7,
  toList as toListx6x8nvfmvvht,
  toSet as toSet2morh2kqexfa2,
  zipWithNext as zipWithNext1coaflhq3atps,
};
//endregion

//# sourceMappingURL=_Sequences.mjs.map
